import { useSelector } from "react-redux";
import { useUpdateWorkbookMutation } from "../../dataApiSlice";
import { useEffect, useState, useCallback } from "react";
import debounce from "lodash.debounce";

const DraftSaveComponent = ({
  isPublishError,
  publishError,
  isPublishLoading,
  isPublishSuccess,
}) => {
  const [
    updateWorkbook,
    {
      isLoading: isUpdateWorkBookLoading,
      isSuccess: isUpdateWorkBookSuccess,
      isError: isUpdateWorkBookError,
      error: updateWorkBookError,
    },
  ] = useUpdateWorkbookMutation();

  const currentState = useSelector((state) => state.Workbook.present);
  // console.log(currentState);

  const [status, setStatus] = useState("");
  // console.log(status);

  const debounceUpdateWorkbook = useCallback(
    debounce((body) => {
      // console.log(body);
      updateWorkbook(body);
    }, 500),
    [updateWorkbook]
  );

  useEffect(() => {
    if (currentState) {
      setStatus("Saving...");
      const body = {
        _id: currentState._id,
        draftId: currentState.draftId,
        icon: null,
        name: currentState.name,
        createdOn: currentState.createdOn,
        commonFilters: currentState.commonFilters,
        calculatedFields: currentState.calculatedFields,
        folderId: currentState.folderId,
        hierarchy: currentState.hierarchy,
        sheetsData: currentState.sheets,
        selectedSheetId: currentState.selectedSheetId,
        dataSources: currentState.dataSources,
      };
      // console.log(body);
      debounceUpdateWorkbook(body);
    }
  }, [currentState, debounceUpdateWorkbook]);

  useEffect(() => {
    if (isUpdateWorkBookLoading) {
      setStatus("Saving...");
    } else if (isUpdateWorkBookError) {
      setStatus(updateWorkBookError?.data?.message);
    } else if (isUpdateWorkBookSuccess) {
      setStatus("Saved");
    }
  }, [
    isUpdateWorkBookLoading,
    isUpdateWorkBookError,
    isUpdateWorkBookSuccess,
    updateWorkBookError,
  ]);

  useEffect(() => {
    if (isPublishLoading) {
      setStatus("Saving...");
    } else if (isPublishError) {
      setStatus(publishError["data"]["message"]);
    } else if (isPublishSuccess) {
      setStatus("Saved");
    }
  }, [isPublishError, publishError, isPublishLoading, isPublishSuccess]);

  return <div className="truncate">{status}</div>;
};

export default DraftSaveComponent;
